export const ToastContainer = ({ children }) => (
  <div
    style={{ zIndex: 99 }}
    className="absolute top-0 right-0 flex justify-end box-border max-h-full w-full overflow-x-hidden overflow-y-auto"
  >
    {children}
  </div>
)
